import alpineIndex from "@/js/alpine";
import eventsIndex  from "@/js/events";
import modulesIndex  from "@/js/modules";

export default function theme(){
    alpineIndex()
    eventsIndex()
    modulesIndex()
}
